<div class="tw-flex tw-w-full tw-flex-col tw-p-6 tw-bg-[#171616] tw-gap-6 tw-h-full">
    <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
        <img src="assets/brokerage/kotakNeo.png" alt="Kotak Neo" class="tw-h-7" />
        <common-icons iconName="x" class="tw-w-5 tw-h-4 tw-cursor-pointer" (click)="closeDialog()"></common-icons>
    </div>

    <div class="tw-flex tw-w-full tw-flex-col tw-gap-1 tw-items-center tw-justify-between">
        <h2 class="tw-text-white mb-2">Login</h2>
        <p class="tw-para-2 tw-text-neutral-100">Use your kotak neo credential</p>
    </div>

    <form [formGroup]="kotakLoginForm" (ngSubmit)="submitKotakLogin()"
        class="tw-flex tw-w-full tw-flex-col tw-h-full !tw-justify-between">
        <div class="tw-flex tw-w-full tw-gap-2 tw-flex-col">
            <div class="tw-flex tw-w-full tw-gap-1 tw-flex-col">
                <label class="tw-para-2 !tw-text-neutral-100">Mobile number</label>
                <div class="tw-flex tw-w-full tw-items-center tw-gap-2">
                    <pickright-input placeholder="+91" formControlName="countryCode"
                        class="tw-w-[80px]"></pickright-input>
                    <pickright-input #mobileInput placeholder="Enter Mobile number" formControlName="mobileNumber"
                        class="tw-flex-1"></pickright-input>
                </div>
            </div>
            <div class="tw-flex tw-w-full tw-flex-row tw-h-full tw-gap-2">
                <div class="tw-flex tw-w-full tw-gap-1 tw-flex-col">
                    <label class="tw-para-2 !tw-text-neutral-100">UCC</label>
                    <pickright-input placeholder="Enter UCC" formControlName="ucc"
                        class="tw-w-full"></pickright-input>
                </div>
                <div class="tw-flex tw-w-full tw-gap-1 tw-flex-col">
                    <label class="tw-para-2 !tw-text-neutral-100">TOTP</label>
                    <pickright-input placeholder="Enter TOTP" formControlName="totp"
                        class="tw-w-full"></pickright-input>
                </div>
            </div>
            <div class="tw-flex tw-w-full tw-gap-1 tw-flex-col">
                <label class="tw-para-2 !tw-text-neutral-100">MPIN</label>
                <pickright-input placeholder="Enter MPIN" type="password" formControlName="mpin"
                    class="tw-w-full"></pickright-input>
            </div>
        </div>
        <pickright-button text="Continue" type="fill" class="tw-flex tw-w-full" [disabled]="kotakLoginForm.invalid"
            (btnClick)="submitKotakLogin()"></pickright-button>
    </form>
</div>